<template>
  <div class="timeline">
    <div class="timeline__item timeline__item--first" :class="{ 'timeline__item--active': active === -1 }" @click="onSelect(-1)">
      Весь день
    </div>
    <div class="timeline__item" v-for="(item, index) in timeList" :key="`time-${index}`" :class="[
    active === index ? 'timeline__item--active' : '', `timeline__item--${parseInt(item)}`]" @click="onSelect(index)">
      {{ item }}
    </div>
    <div class="timeline__item timeline__item--last" :class="{ 'timeline__item--active': active === timeListLength }"  @click="onSelect(timeListLength)">
      00:00
    </div>
  </div>
</template>

<script>
export default {
  props: {
    timeList: Array,
    active: Number
  },
  computed: {
    timeListLength () {
      return this.timeList.length
    }
  },
  methods: {
    onSelect (index) {
      this.$emit('change', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.timeline {
  display: flex;
  // justify-content: space-between;
  position: relative;

  &::after {
    background: $theme-gray-600;
    bottom: 0;
    content: '';
    display: block;
    height: 2px;
    left: 32px;
    position: absolute;
    right: 17px;
  }

  &__item {
    @include font-size($font-size-lg);
    cursor: pointer;
    font-weight: 600;
    line-height: 1.3;
    margin-left: 50px;
    padding-bottom: 13px;
    position: relative;
    transition: color 150ms ease;

    @include media-breakpoint-up(lg) {
      margin-left: 100px;
    }

    &::after {
      background: $body-bg;
      border-radius: 50%;
      border: 2px solid $theme-gray-600;
      bottom: -5px;
      content: '';
      display: block;
      height: 13px;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
      transition: border-color 150ms ease;
      width: 13px;
      z-index: 1;
    }

    &:hover,
    &--active {
      color: $theme-red-100;

      &::after {
        border-color: $theme-red-100;
      }
    }

    &--active {
      &::after {
        border-width: 4px;
      }
    }

    &.timeline__item--first {
      margin-left: 0;
    }

    &.timeline__item--8 {
      margin-left: 25px;

      @include media-breakpoint-up(lg) {
        margin-left: 50px;
      }
    }

    &.timeline__item--19 {
      margin-left: auto;
    }

    &.timeline__item--11 {
      margin-left: 25px;

      @include media-breakpoint-up(lg) {
        margin-left: 50px;
      }
    }

    &.timeline__item--22 {
      margin-left: 75px;

      @include media-breakpoint-up(lg) {
        margin-left: 150px;
      }
    }
  }
}
</style>
